"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    height: "24",
    viewBox: "0 0 56.2 24",
    width: "56.2",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m55.37 15.2h-11v-13.65a.76.76 0 0 0 -.75-.75h-31a.76.76 0 0 0 -.75.75v13.65h-11.04a.78.78 0 0 0 0 1.56h3.82a3.91 3.91 0 1 0 4.06 0h3.86a3.91 3.91 0 1 0 5.94 3.33 3.44 3.44 0 0 0 -.05-.45.81.81 0 0 0 .53.2h17.7a.75.75 0 0 0 .36-.1v.35a3.91 3.91 0 1 0 6-3.33h3.86a3.91 3.91 0 1 0 4.06 0h4.49a.78.78 0 0 0 0-1.56zm-46.37 4.89a2.35 2.35 0 1 1 -2.35-2.36 2.35 2.35 0 0 1 2.35 2.36zm5.57 2.35a2.4 2.4 0 1 1 .06 0zm3.56-3.94a3.86 3.86 0 0 0 -1.53-1.74h1.53zm19.35-.27v-1.47h1.42a4 4 0 0 0 -1.39 1.47zm5.77 1.86a2.35 2.35 0 1 1 -2.35-2.36 2.35 2.35 0 0 1 2.35 2.36zm7.92 0a2.36 2.36 0 1 1 -2.36-2.36 2.35 2.35 0 0 1 2.38 2.32z",
    fill: "#93c01f"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m23.54 13.86v-10.96l9.12 5.48z",
    fill: "#fff"
  }));
};

exports["default"] = _default;